/* ============================================================
   WIT & REBELLION CO. — IVORY BOUTIQUE v6
   theme.js — single source of truth for all interactions
   (inline duplicates removed from sections in v6)
   ============================================================ */
(function () {
  'use strict';

  /* ── STICKY HEADER ───────────────────────────────────── */
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    header?.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });

  /* ── CART DRAWER ─────────────────────────────────────── */
  const overlay = document.querySelector('.cart-overlay');

  function getDrawer() { return document.querySelector('.cart-drawer'); }
  function openCart()  { getDrawer()?.classList.add('is-open');    overlay?.classList.add('is-open');    document.body.style.overflow = 'hidden'; }
  function closeCart() { getDrawer()?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }

  document.querySelectorAll('.js-cart-open').forEach(b => b.addEventListener('click', openCart));
  document.addEventListener('click', e => { if (e.target.closest('.js-cart-close')) closeCart(); });
  overlay?.addEventListener('click', closeCart);

  /* Re-render the drawer from the live cart via the Section Rendering API */
  async function renderCartDrawer() {
    try {
      const res  = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh   = tmp.querySelector('.cart-drawer');
      const current = getDrawer();
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch {}
  }

  /* Remove a line item from inside the drawer without a page reload */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-line-remove');
    if (!btn) return;
    btn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 })
      });
      await Promise.all([renderCartDrawer(), refreshCartCount()]);
    } catch { btn.disabled = false; }
  });

  /* ── ADD TO CART ─────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-atc');
    if (!btn) return;
    const id = btn.dataset.variantId;
    if (!id) return;
    const wrap  = btn.closest('.product-page__atc-row') || btn.closest('form');
    const qty   = parseInt(wrap?.querySelector('.js-qty')?.value) || 1;
    const label = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      });
      if (res.ok) {
        btn.textContent = 'Added ✓';
        await Promise.all([refreshCartCount(), renderCartDrawer()]);
        openCart();
        setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
      } else {
        const err = await res.json();
        btn.textContent = err.description || 'Unavailable';
        setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
      }
    } catch { btn.textContent = label; btn.disabled = false; }
  });

  /* ── CART COUNT ──────────────────────────────────────── */
  async function refreshCartCount() {
    try {
      const data = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent   = data.item_count;
        el.style.display = data.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch {}
  }

  /* ── STICKY ATC ──────────────────────────────────────── */
  const mainAtc   = document.querySelector('.product-page__atc-btn');
  const stickyAtc = document.querySelector('.sticky-atc');
  if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => stickyAtc.classList.toggle('is-visible', !e.isIntersecting), { threshold: 0 }).observe(mainAtc);
    document.querySelector('.js-sticky-atc')?.addEventListener('click', () => mainAtc.click());
  }

  /* ── VARIANT RESOLUTION ──────────────────────────────── */
  /* One select per option; the matching variant is found in the
     embedded JSON so multi-option products (Size × Color) resolve
     to the correct variant id, price, and availability. */
  const optionSelects = document.querySelectorAll('.js-option-select');
  const variantScript = document.querySelector('.js-variant-data');

  if (optionSelects.length && variantScript) {
    let variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch {}
    const moneyFormat = variantScript.dataset.moneyFormat || '${{amount}}';

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const noDec  = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    };

    const productAtcBtns = () => document.querySelectorAll('.js-product-atc, .js-sticky-atc');

    const updateVariant = () => {
      const chosen = [...optionSelects].map(s => s.value);
      const match  = variants.find(v => chosen.every((val, i) => v['option' + (i + 1)] === val));
      const priceEls = document.querySelectorAll('.js-price, .sticky-atc__price');
      const compare  = document.querySelector('.js-compare');

      if (!match) {
        productAtcBtns().forEach(b => { b.textContent = 'Unavailable'; b.disabled = true; });
        return;
      }

      priceEls.forEach(el => el.textContent = formatMoney(match.price));

      /* Low-stock scarcity note */
      const lowStockEl  = document.querySelector('.js-low-stock');
      const lowStockMax = parseInt(variantScript.dataset.lowStock, 10) || 0;
      if (lowStockEl) {
        const qty = match.inventory_quantity;
        const tracked = match.inventory_management != null;
        if (lowStockMax > 0 && tracked && qty > 0 && qty <= lowStockMax) {
          lowStockEl.textContent = `Only ${qty} left`;
          lowStockEl.style.display = '';
        } else {
          lowStockEl.style.display = 'none';
        }
      }
      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.textContent = formatMoney(match.compare_at_price);
          compare.style.display = '';
        } else {
          compare.style.display = 'none';
        }
      }

      productAtcBtns().forEach(b => {
        b.dataset.variantId = match.id;
        b.disabled = !match.available;
        if (!b.classList.contains('js-sticky-atc')) {
          b.textContent = match.available ? 'Add to Bag' : 'Sold Out';
        }
      });

      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      } catch {}
    };

    optionSelects.forEach(s => s.addEventListener('change', updateVariant));
    updateVariant();
  }

  /* ── IMAGE ZOOM LIGHTBOX (pinch / pan / double-tap / wheel) ── */
  const zoomBox  = document.querySelector('.js-zoom-lightbox');
  const zoomImg  = document.querySelector('.js-zoom-img');
  const zoomStage= document.querySelector('.js-zoom-stage');
  const zoomHint = document.querySelector('.js-zoom-hint');
  const zoomTrig = document.querySelector('.js-zoom-trigger');

  if (zoomBox && zoomImg && zoomStage && zoomTrig) {
    const MIN = 1, MAX = 4;
    let scale = 1, panX = 0, panY = 0;
    const pointers = new Map();
    let pinchStartDist = 0, pinchStartScale = 1;
    let lastTap = 0, suppressClick = false;

    const apply = () => {
      zoomImg.style.transform =
        `translate(-50%, -50%) translate(${panX}px, ${panY}px) scale(${scale})`;
    };

    const clampPan = () => {
      /* keep at least part of the image on screen */
      const limX = (zoomImg.offsetWidth  * scale) / 2;
      const limY = (zoomImg.offsetHeight * scale) / 2;
      panX = Math.max(-limX, Math.min(limX, panX));
      panY = Math.max(-limY, Math.min(limY, panY));
    };

    const reset = () => { scale = 1; panX = 0; panY = 0; apply(); };

    const setScale = (next) => {
      scale = Math.max(MIN, Math.min(MAX, next));
      if (scale === 1) { panX = 0; panY = 0; }
      clampPan(); apply();
      if (zoomHint) zoomHint.style.opacity = scale > 1 ? '0' : '';
    };

    function openZoom() {
      zoomImg.src = zoomTrig.dataset.zoomSrc || zoomTrig.src;
      reset();
      if (zoomHint) zoomHint.style.opacity = '';
      zoomBox.classList.add('is-open');
      zoomBox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      zoomBox.classList.remove('is-open');
      zoomBox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      pointers.clear();
    }

    zoomTrig.addEventListener('click', openZoom);
    document.querySelector('.js-zoom-close')?.addEventListener('click', closeZoom);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeZoom(); });

    /* tap empty backdrop to close (not while zoomed/panning) */
    zoomStage.addEventListener('click', (e) => {
      if (suppressClick) { suppressClick = false; return; }
      if (e.target === zoomStage && scale === 1) closeZoom();
    });

    /* double-tap / double-click toggles 2.5x */
    const doubleTap = () => setScale(scale > 1 ? 1 : 2.5);
    zoomImg.addEventListener('dblclick', (e) => { e.preventDefault(); doubleTap(); });

    zoomStage.addEventListener('pointerdown', (e) => {
      zoomStage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        pinchStartDist  = Math.hypot(a.x - b.x, a.y - b.y);
        pinchStartScale = scale;
      }
      if (e.pointerType === 'touch' && pointers.size === 1) {
        const now = Date.now();
        if (now - lastTap < 300) doubleTap();
        lastTap = now;
      }
      zoomStage.classList.add('is-panning');
    });

    zoomStage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      const prev = pointers.get(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        const dist = Math.hypot(a.x - b.x, a.y - b.y);
        if (pinchStartDist > 0) setScale(pinchStartScale * (dist / pinchStartDist));
        suppressClick = true;
      } else if (pointers.size === 1 && scale > 1) {
        panX += e.clientX - prev.x;
        panY += e.clientY - prev.y;
        clampPan(); apply();
        suppressClick = true;
      }
    });

    const lift = (e) => {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinchStartDist = 0;
      if (pointers.size === 0) zoomStage.classList.remove('is-panning');
    };
    zoomStage.addEventListener('pointerup', lift);
    zoomStage.addEventListener('pointercancel', lift);

    /* desktop wheel zoom */
    zoomStage.addEventListener('wheel', (e) => {
      e.preventDefault();
      setScale(scale * (e.deltaY < 0 ? 1.12 : 0.89));
    }, { passive: false });
  }

  /* ── DESKTOP HOVER MAGNIFIER (product main photo) ────── */
  if (zoomTrig && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const magWrap = zoomTrig.closest('.product-page__main-img');
    if (magWrap) {
      const lens = document.createElement('div');
      lens.className = 'img-magnifier';
      magWrap.appendChild(lens);

      magWrap.addEventListener('mouseenter', () => {
        lens.style.backgroundImage = `url("${zoomTrig.dataset.zoomSrc || zoomTrig.src}")`;
        lens.style.backgroundSize = (parseInt(zoomTrig.dataset.mag, 10) || 190) + '%';
        lens.classList.add('is-active');
      });
      magWrap.addEventListener('mousemove', (e) => {
        const r = magWrap.getBoundingClientRect();
        lens.style.backgroundPosition =
          `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
      magWrap.addEventListener('mouseleave', () => lens.classList.remove('is-active'));
    }
  }

  /* ── GALLERY THUMBNAILS ──────────────────────────────── */
  /* Full-resolution URLs come from data attributes rendered by
     Liquid — no URL string surgery, no blurry upscaled thumbs. */
  document.querySelectorAll('.js-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.js-main-img');
      if (!main) return;
      if (thumb.dataset.full)   main.src    = thumb.dataset.full;
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      if (thumb.dataset.zoom)   main.dataset.zoomSrc = thumb.dataset.zoom;
      document.querySelectorAll('.js-thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* ── QUANTITY ────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('.js-qty-dec');
    const inc = e.target.closest('.js-qty-inc');
    const inp = (dec || inc)?.closest('.qty-wrap')?.querySelector('.js-qty');
    if (!inp) return;
    const v = parseInt(inp.value) || 1;
    const min = parseInt(inp.min) || 1;
    if (dec && v > min) inp.value = v - 1;
    if (inc) inp.value = v + 1;
  });

  /* ── SCROLL REVEAL ───────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
  }

  /* ── MOBILE MENU ─────────────────────────────────────── */
  const mobileNav = document.querySelector('.mobile-nav');
  document.querySelector('.js-menu-open')?.addEventListener('click',  () => { mobileNav?.classList.add('is-open');    document.body.style.overflow = 'hidden'; });
  document.querySelector('.js-menu-close')?.addEventListener('click', () => { mobileNav?.classList.remove('is-open'); document.body.style.overflow = ''; });

  /* ── BACK TO TOP ─────────────────────────────────────── */
  const btt = document.querySelector('.back-to-top');
  if (btt) {
    window.addEventListener('scroll', () => btt.classList.toggle('is-visible', window.scrollY > 600), { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ── FAQ ACCORDION (single handler — inline copy removed) ── */
  document.querySelectorAll('.faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq__item').forEach(i => { i.classList.remove('is-open'); i.querySelector('.faq__question')?.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ── COLLECTION SORT (preserves existing URL params) ─── */
  document.querySelector('.collection-page__sort-select')?.addEventListener('change', function () {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ── PREDICTIVE SEARCH ───────────────────────────────── */
  const searchInput = document.querySelector('.js-search-input');
  const searchDrop  = document.querySelector('.js-search-results');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { if (searchDrop) searchDrop.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const data = await (await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)).json();
        const products = data.resources?.results?.products || [];
        if (!searchDrop) return;
        if (!products.length) { searchDrop.innerHTML = '<p style="font-family:var(--font-serif);font-style:italic;font-size:15px;color:var(--text-mid);padding:16px 20px;">No results found.</p>'; return; }
        searchDrop.innerHTML = products.map(p => `
          <a href="${p.url}" style="display:flex;align-items:center;gap:14px;padding:12px 20px;border-bottom:1px solid rgba(176,140,82,.1);text-decoration:none;transition:background .2s;" onmouseover="this.style.background='rgba(176,140,82,.05)'" onmouseout="this.style.background=''">
            ${p.featured_image?.url ? `<img src="${p.featured_image.url}&width=80" alt="${p.title}" style="width:48px;height:60px;object-fit:cover;flex-shrink:0;">` : `<div style="width:48px;height:60px;background:var(--ivory-3);flex-shrink:0;"></div>`}
            <div>
              <p style="font-family:var(--font-display);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--obsidian);margin-bottom:3px;">${p.title}</p>
              <p style="font-family:var(--font-serif);font-size:14px;color:var(--gold);">${p.price ? '$' + (parseInt(p.price) / 100).toFixed(2) : ''}</p>
            </div>
          </a>`).join('');
      } catch {}
    }, 280);
  });
  document.addEventListener('click', e => { if (!e.target.closest('.js-search-wrap') && searchDrop) searchDrop.innerHTML = ''; });

  /* ── FOOTER CTA FORM (single handler — inline copy removed) ── */
  document.querySelector('.js-footer-cta-form')?.addEventListener('submit', async function (e) {
    e.preventDefault();
    const btn   = this.querySelector('.footer-cta__btn');
    const input = this.querySelector('input[type="email"]');
    if (!input?.value) return;
    const label = btn.textContent;
    btn.textContent = 'Joining…'; btn.disabled = true;
    try {
      await fetch(this.action, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams(new FormData(this)) });
      btn.textContent = 'Welcome ✓'; input.value = '';
    } catch { btn.textContent = label; btn.disabled = false; }
  });

  /* ── INIT ────────────────────────────────────────────── */
  refreshCartCount();

})();
